  <ngb-carousel class="carusel">
		<ng-template ngbSlide>
			<div class="picsum-img-wrapper">
				<img src="assets/images/carouselHome/coam_01.jpg" alt="-" />
			</div>
		</ng-template>
		<ng-template ngbSlide>
			<div class="picsum-img-wrapper">
				<img src="assets/images/carouselHome/coam_02.jpg" alt="-" />
			</div>
		</ng-template>
		<ng-template ngbSlide>
			<div class="picsum-img-wrapper">
				<img src="assets/images/carouselHome/coam_03.jpg" alt="-" />
			</div>
		</ng-template>
		<ng-template ngbSlide>
			<div class="picsum-img-wrapper">
				<img src="assets/images/carouselHome/coam_04.jpg" alt="-" />
			</div>
		</ng-template>
		<ng-template ngbSlide>
			<div class="picsum-img-wrapper">
				<img src="assets/images/carouselHome/coam_05.jpg" alt="-" />
			</div>
		</ng-template>
		<ng-template ngbSlide>
			<div class="picsum-img-wrapper">
				<img src="assets/images/carouselHome/coam_06.jpg" alt="-" />
			</div>
		</ng-template>
		<ng-template ngbSlide>
			<div class="picsum-img-wrapper">
				<img src="assets/images/carouselHome/coam_07.jpg" alt="-" />
			</div>
		</ng-template>
		<ng-template ngbSlide>
			<div class="picsum-img-wrapper">
				<img src="assets/images/carouselHome/coam_08.jpg" alt="-" />
			</div>
		</ng-template>
		<ng-template ngbSlide>
			<div class="picsum-img-wrapper">
				<img src="assets/images/carouselHome/coam_09.jpg" alt="-" />
			</div>
		</ng-template>
		<ng-template ngbSlide>
			<div class="picsum-img-wrapper">
				<img src="assets/images/carouselHome/coam_10.jpg" alt="-" />
			</div>
		</ng-template>
		<ng-template ngbSlide>
			<div class="picsum-img-wrapper">
				<img src="assets/images/carouselHome/coam_11.jpg" alt="-" />
			</div>
		</ng-template>
		<ng-template ngbSlide>
			<div class="picsum-img-wrapper">
				<img src="assets/images/carouselHome/coam_12.jpg" alt="-" />
			</div>
		</ng-template>
	</ngb-carousel>